import CloseIcon from "@mui/icons-material/Close";
import CommentIcon from "@mui/icons-material/Comment";
import DeleteIcon from "@mui/icons-material/Delete";
import DragHandleIcon from "@mui/icons-material/DragHandle";
import EditIcon from "@mui/icons-material/Edit";
import FitScreenIcon from "@mui/icons-material/FitScreen";
import HistoryIcon from "@mui/icons-material/History";
import UploadIcon from "@mui/icons-material/Upload";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import ZoomOutIcon from "@mui/icons-material/ZoomOut";
import {
  Backdrop,
  Badge,
  Card,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Icon,
  IconButton,
  Menu,
  MenuItem,
  Radio,
  RadioGroup,
  Switch,
  Tooltip,
} from "@mui/material";
import {
  DataGridPro,
  GridToolbarContainer,
  GridToolbarDensitySelector,
  GridToolbarExport,
  GridToolbarFilterButton,
  useGridApiRef,
} from "@mui/x-data-grid-pro";
import { LicenseInfo } from "@mui/x-license-pro";
import { Document, Font, Image, Page, StyleSheet, Text, View, pdf } from "@react-pdf/renderer";
import { Upload } from "antd";
import notoSans from "assets/fonts/NotoSansSC-Regular.otf";
import SuiBox from "components/SuiBox";
import SuiButton from "components/SuiButton";
import SuiInput from "components/SuiInput";
import SuiSelect from "components/SuiSelect";
import SuiTypography from "components/SuiTypography";
import ContactAvatar from "components/UpStyled/ContactAvatar";
import DropZone from "components/UpStyled/DropZone";
import FilePreviewCard from "components/UpStyled/FilePreviewCard";
import Prompt from "components/UpStyled/Prompt";
import Compressor from "compressorjs";
import { saveAs } from "file-saver";
import moment from "moment";
import { nanoid } from "nanoid";
import Papa from "papaparse";
import { useEffect, useRef, useState } from "react";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import toast from "react-hot-toast";
import { GiCancel, GiCheckMark } from "react-icons/gi";
import { TiCancel } from "react-icons/ti";
import api from "services/api";
import { dataURLtoFile, getBase64, getImageDimensions, handleUploadFiles } from "utils/imageHelper";
import Sketch, {
  AnnotationColors,
  AnnotationMethods,
  EditAnnot,
  EditComments,
  SketchToolTip,
  autoCalc,
  describePEP,
  getImageDataUrl,
} from "./Sketch";

import ImportMaterialModal from "pages/de/material-library/components/ImportMaterialModal";
import { materialCategoryOptions } from "utils/data";

LicenseInfo.setLicenseKey(
  "7addb1959b1b3df49bbd9c4c58ee24ceTz02MTA3NCxFPTE3MDkzMjQxODY1ODksUz1wcm8sTE09c3Vic2NyaXB0aW9uLEtWPTI="
);
var deepEqual = require("deep-equal");
const smartdate = require("smartdate");
smartdate.init();

const deletePEPAttr = (obj) => {
  delete obj.v;
  delete obj.PEProle;
  delete obj.PEPname;
  delete obj.PEPdate;
  delete obj.PEPvalue;
};

export const countBoardCollaborationUpdates = (detail, board, selectedRows = null) => {
  var myCount = 0;
  var otherCount = 0;
  if (board) {
    for (var sketchData of board.sketchdatas) {
      for (var line of sketchData.lines) {
        if (selectedRows !== null && !selectedRows.includes(line.id)) continue;
        if ("PEProle" in line) {
          if (line.PEProle === detail.user_id) ++myCount;
          else ++otherCount;
        }
        Object.keys(line.datas).forEach((key) => {
          var cellValue = line.datas[key];
          if (typeof cellValue === "object" && "PEProle" in cellValue) {
            if (cellValue.PEProle === detail.user_id) ++myCount;
            else ++otherCount;
          }
        });
      }
    }
    if (selectedRows === null) {
      for (var field of board.fields) {
        if ("PEProle" in field) {
          if (field.PEProle === detail.user_id) ++myCount;
          else ++otherCount;
        }
      }
    }
  }
  //console.log('myCount', myCount, 'otherCount', otherCount)
  return { myCount, otherCount };
};

export const collaborationActions = (
  board,
  sketchdatas,
  checkrole,
  isAccept,
  selectedRows = null,
  addCollaborationHistory = null
) => {
  var newDatas = sketchdatas.map((sketchdata) => {
    var newlines;
    newlines = sketchdata.lines.map((line) => {
      if (selectedRows === null || selectedRows.includes(line.id)) {
        var newline = JSON.parse(JSON.stringify(line));
        if (newline.PEProle !== undefined && checkrole(newline.PEProle)) {
          if (isAccept && addCollaborationHistory) {
            addCollaborationHistory({
              ...newline,
              datas: undefined,
              type: "row",
              linecode: newline.index,
              PEPname: newline.PEPname,
            });
          }
          if ((isAccept && newline.v === "") || (!isAccept && newline.PEPvalue === "")) {
            deletePEPAttr(newline);
          } else if ((isAccept && newline.PEPvalue === "") || (!isAccept && newline.v === ""))
            return null;
        }
        Object.keys(newline.datas).forEach((key) => {
          var cellValue = newline.datas[key];
          if (
            typeof cellValue === "object" &&
            cellValue.PEProle !== undefined &&
            checkrole(cellValue.PEProle)
          ) {
            if (isAccept && addCollaborationHistory) {
              addCollaborationHistory({
                ...cellValue,
                type: "cell",
                field: board.fields.find((f) => f.field === key)?.headerName,
                linecode: newline.index,
              });
            }
            newline.datas[key] = isAccept ? cellValue.PEPvalue : cellValue.v;
          }
        });
        return newline;
      } else {
        return line;
      }
    });
    newlines = newlines.filter((line) => {
      return line !== null;
    });
    return { ...sketchdata, lines: newlines };
  });
  if (board.id === "BillMaterials")
    newDatas = newDatas.filter((sketchdata) => sketchdata.lines.length > 0);
  var newFields = board.fields.map((field) => {
    var newField = JSON.parse(JSON.stringify(field));
    if (selectedRows === null && "PEProle" in newField && checkrole(newField.PEProle)) {
      if (isAccept && addCollaborationHistory) {
        addCollaborationHistory({ ...newField, type: "field" });
      }
      if ((isAccept && newField.v === "") || (!isAccept && newField.PEPvalue === "")) {
        deletePEPAttr(newField);
      } else if ((isAccept && newField.PEPvalue === "") || (!isAccept && newField.v === ""))
        return null;
    }
    return newField;
  });
  newFields = newFields.filter((field) => {
    return field !== null;
  });
  return { newDatas: newDatas, newFields: newFields };
};

export const ExportPdf = ({
  detail,
  exportPdfDialogVisible,
  setExportPdfDialogVisible,
  boards,
  styleTitle,
}) => {
  const borderColor = "#585858";
  const [isPortrait, setIsPortrait] = useState(false);
  const [imgHeight, setImgHeight] = useState(300);
  Font.register({ src: notoSans, family: "Noto Sans SC" });
  //595 x 842
  const generatePdfDocument = async () => {
    const styles = StyleSheet.create({
      page: {
        fontFamily: "Helvetica",
        padding: 10,
        flexDirection: "column",
      },
      tableContainer: {
        display: "table",
        flexDirection: "row",
        flexWrap: "wrap",
        width: "100%",
        marginTop: 24,
      },
      headerRow: {
        display: "table-row",
        flexDirection: "row",
        flexWrap: "nowrap",
        alignItems: "center",
        textAlign: "center",
        borderTopWidth: 1,
        borderBottomWidth: 1,
        borderLeftWidth: 1,
        borderColor: borderColor,
        backgroundColor: "lightgrey",
        width: "100%",
      },
      row: {
        display: "table-cell",
        flexDirection: "row",
        flexWrap: "nowrap",
        alignItems: "center",
        textAlign: "center",
        borderLeftWidth: 1,
        borderBottomWidth: 1,
        borderColor: borderColor,
        width: "100%",
      },
    });
    var sketchList = [];
    for (var board of boards) {
      if (board.sketchdatas.length === 0) continue;
      var boardTitle = board.title ?? board.id;
      const fields = board.fields
        .filter((f) => {
          return !f.hide;
        })
        .map((f) => {
          return { ...f, width: Math.min(300, f.width) };
        });
      if (board.id === "BillMaterials") {
        var combineddata = { lines: [] };
        for (var sketchdata of board.sketchdatas) {
          combineddata.lines.push({ ...sketchdata.lines[0] });
        }
        if (combineddata.lines.length > 0) sketchList.push([combineddata, boardTitle, fields]);
      } else {
        for (var sketchdata of board.sketchdatas) sketchList.push([sketchdata, boardTitle, fields]);
      }
    }
    const GetPdfContent = () => {
      return (
        <Document>
          <Page size="A4" orientation={isPortrait ? "portrait" : "landscape"} style={styles.page}>
            {sketchList.map(([sketchdata, boardTitle, fields], index) => {
              //console.log('sketchdata', sketchdata)
              const uri = "imgurl" in sketchdata ? getImageDataUrl(detail, sketchdata) : null;
              const imgWidth =
                (sketchdata.rotation == 1 || sketchdata.rotation == 3
                  ? sketchdata.height / sketchdata.width
                  : sketchdata.width / sketchdata.height) * imgHeight;
              //console.log('imgWidth', imgWidth, 'imgHeight', imgHeight)
              return (
                <View
                  key={sketchdata.id}
                  break={index > 0}
                  style={{ display: "flex", flexDirection: "column" }}
                >
                  <View
                    fixed
                    style={{
                      flexDirection: "row",
                      width: "100%",
                      justifyContent: "space-between",
                      borderBottomWidth: 1,
                      borderColor: borderColor,
                    }}
                  >
                    <Text
                      key={"dtitle_" + sketchdata.id}
                      style={{
                        textAlign: "left",
                        fontSize: 18,
                        width: "100%",
                        textOverflow: "ellipsis",
                        overflow: "hidden",
                        paddingBottom: 5,
                        paddingTop: 5,
                      }}
                    >
                      {styleTitle}
                    </Text>
                    <Text
                      key={"btitle_" + sketchdata.id}
                      style={{
                        textAlign: "center",
                        fontSize: 18,
                        width: "100%",
                        textOverflow: "ellipsis",
                        overflow: "hidden",
                        paddingBottom: 5,
                        paddingTop: 5,
                      }}
                    >
                      {boardTitle}
                    </Text>
                    <Text
                      key={"bempty_" + sketchdata.id}
                      style={{
                        textAlign: "right",
                        fontSize: 18,
                        width: "100%",
                        textOverflow: "ellipsis",
                        overflow: "hidden",
                        paddingBottom: 5,
                        paddingTop: 5,
                      }}
                    ></Text>
                  </View>
                  {uri && (
                    <View
                      style={{
                        flexDirection: "row",
                        width: "100%",
                        justifyContent: "center",
                        backgroundColor: "#F5F5F5",
                        borderLeftWidth: 1,
                        borderRightWidth: 1,
                        borderBottomWidth: 1,
                        borderColor: borderColor,
                      }}
                    >
                      <Image
                        src={uri}
                        style={{ width: imgWidth, height: imgHeight, paddingTop: 0 }}
                      />
                    </View>
                  )}
                  {fields.length > 0 && (
                    <View style={styles.tableContainer}>
                      <View key="header" style={styles.headerRow} wrap={false}>
                        {fields.map((f, index) => {
                          f.width = f.width ?? 64;
                          var name = f.headerName;
                          return (
                            <Text
                              key={f.id}
                              style={{
                                fontFamily: "Noto Sans SC",
                                fontSize: 14,
                                paddingVertical: 2,
                                width: f.width,
                                flexGrow: index == -1 ? 0 : f.width / 100,
                                height: "100%",
                                borderRightWidth: 1,
                                borderColor: borderColor,
                                textDecoration: "PEProle" in f ? "line-through" : "",
                              }}
                            >
                              {name}
                            </Text>
                          );
                        })}
                      </View>
                      {sketchdata.lines.map((line) => {
                        var row = { ...line.datas, Code: line.index };
                        if ("PEProle" in line) row.Code = line;
                        return (
                          <View key={line.index} style={styles.row} wrap={false}>
                            {fields.map((f, index) => {
                              var cell = row[f.field] ?? " ";
                              if (f.field === "ImageData") {
                                var imgdata =
                                  typeof cell === "object" && "PEProle" in cell
                                    ? cell.PEPvalue
                                    : cell;
                                console.log(
                                  "f.width",
                                  f.width,
                                  (40 * imgdata.width) / imgdata.height,
                                  imgdata
                                );
                                return (
                                  <View
                                    style={{
                                      flexDirection: "row",
                                      width: f.width,
                                      justifyContent: "center",
                                      borderRightWidth: 1,
                                      borderColor: borderColor,
                                    }}
                                  >
                                    <Image
                                      src={imgdata.imgurl}
                                      style={{
                                        height: 40,
                                        width: (40 * imgdata.width) / imgdata.height,
                                        paddingTop: 0,
                                      }}
                                    />
                                  </View>
                                );
                              }
                              return (
                                <Text
                                  key={line.index + "_" + f.field}
                                  style={{
                                    fontFamily: "Noto Sans SC",
                                    fontSize: 12,
                                    paddingVertical: 2,
                                    width: f.width,
                                    flexGrow: index == -1 ? 0 : f.width / 100,
                                    height: "100%",
                                    borderRightWidth: 1,
                                    borderColor: borderColor,
                                    textDecoration:
                                      typeof cell === "object" && cell.PEPvalue === ""
                                        ? "line-through"
                                        : "",
                                  }}
                                >
                                  {" "}
                                  {typeof cell === "object"
                                    ? cell.PEPvalue === ""
                                      ? cell.v
                                      : cell.PEPvalue
                                    : cell}
                                </Text>
                              );
                            })}
                          </View>
                        );
                      })}
                    </View>
                  )}
                </View>
              );
            })}
          </Page>
        </Document>
      );
    };
    //console.log('pdf', GetPdfContent())
    const blob = await pdf(GetPdfContent()).toBlob();
    saveAs(blob, `${styleTitle}.pdf`);
  };

  return (
    <Dialog
      sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: "550px",
            height: "300px",
          },
        },
      }}
      open={exportPdfDialogVisible}
      maxWidth={"lg"}
      onClose={() => setExportPdfDialogVisible(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">Export PDF</DialogTitle>
      <DialogContent>
        <SuiBox sx={{ display: "flex", justifyContent: "space-between" }}>
          <SuiBox ml={0.5} lineHeight={0} display="inline-block">
            <SuiTypography component="label" variant="h6" fontWeight="bold">
              Layout:
            </SuiTypography>
          </SuiBox>
          <RadioGroup
            row
            value={isPortrait ? "portrait" : "landscape"}
            defaultValue={isPortrait ? "portrait" : "landscape"}
            onChange={(e) => {
              setIsPortrait(e.target.value == "portrait");
            }}
            sx={{ gap: 3, alignItems: "center" }}
          >
            <SuiBox className="flex items-center mr-2">
              <Radio value="portrait" key="portrait" />
              <SuiTypography component="label" variant="button" fontWeight="bold" color="dark">
                Portrait
              </SuiTypography>
            </SuiBox>
            <SuiBox className="flex items-center mr-2">
              <Radio value="landscape" key="landscape" />
              <SuiTypography component="label" variant="button" fontWeight="bold" color="dark">
                Landscape
              </SuiTypography>
            </SuiBox>
          </RadioGroup>
        </SuiBox>
        <SuiBox sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}>
          <SuiBox ml={0.5} lineHeight={0} display="inline-block">
            <SuiTypography component="label" variant="h6" fontWeight="bold">
              Image Height in PDF:
            </SuiTypography>
          </SuiBox>
          <SuiBox sx={{ width: "250px" }}>
            <SuiInput
              size="small"
              type="number"
              value={imgHeight}
              onChange={(e) => {
                setImgHeight(e.target.value);
              }}
            />
          </SuiBox>
        </SuiBox>
      </DialogContent>
      <DialogActions>
        <SuiButton
          onClick={() => setExportPdfDialogVisible(false)}
          color={"secondary"}
          variant="gradient"
        >
          Cancel
        </SuiButton>
        <SuiButton
          onClick={() => {
            generatePdfDocument();
            setExportPdfDialogVisible(false);
          }}
          color={"dark"}
          variant="gradient"
        >
          Export
        </SuiButton>
      </DialogActions>
    </Dialog>
  );
};

const DevelopBoard = ({ detail, editmode, board, updateBoard }) => {
  var initMethod = editmode ? "end" : "comments";
  if (board?.id === "Sketches" || board?.id === "BillMaterials") initMethod = "comments";
  const [sketchDatas, setSketchDatas] = useState(
    board
      ? board.sketchdatas.map((s) => {
          return { ...s, lines: s.lines.filter((l) => l.method !== "comments") };
        })
      : []
  );
  const [collaborationHistory, setCollaborationHistory] = useState(
    board?.collaborationhistory ?? []
  );
  const [sketchComments, setSketchComments] = useState({});
  const [tableFields, setTableFields] = useState(board?.fields ?? []);
  const [sketchHeight, setSketchHeight] = useState(board?.id == "BillMaterials" ? 100 : 400);
  const [color, setColor] = useState("Black");
  const [method, setMethod] = useState(initMethod);
  const [imageFilter, setImageFilter] = useState("");
  const [isDragDisabled, setIsDragDisabled] = useState(true);
  const [selectedRows, setSelectedRows] = useState([]);
  const [editColumnDialogVisible, setEditColumnDialogVisible] = useState(false);
  const [addPartsDialogVisible, setAddPartsDialogVisible] = useState(false);
  const [addPartsDialogSketch, setAddPartsDialogSketch] = useState(null);
  const [deleteImgDialogVisible, setDeleteImgDialogVisible] = useState(false);
  const [exportPdfDialogVisible, setExportPdfDialogVisible] = useState(false);
  const [deleteImage, setDeleteImage] = useState(null);
  const [deleteSelectedDialogVisible, setDeleteSelectedDialogVisible] = useState(false);
  const [techPacksFiles, setTechPacksFiles] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [showComments, setShowComments] = useState(false);
  const [commentsDialogVisible, setCommentsDialogVisible] = useState(false);
  const [annotDialogVisible, setAnnotDialogVisible] = useState(false);
  const [currentAnnot, setCurrentAnnot] = useState(null);
  const [currentCell, setCurrentCell] = useState({ show: false });
  const [showHistory, setShowHistory] = useState(false);
  const [contextMenu, setContextMenu] = useState(null);

  const stepHistory = useRef([{ sketchDatas: sketchDatas, tableFields: tableFields }]);
  const stepHistoryIndex = useRef(0);
  const stepHistoryCheck = useRef(1);
  const gridRef = useRef(null);
  const sketchTooltipRef = useRef(null);

  const setSketchToolTip = (tooltip) => {
    if (sketchTooltipRef.current) sketchTooltipRef.current.setSketchToolTip2(tooltip);
  };

  const refreshComments = () => {
    if (board.sketchdatas.length == 0) {
      setShowComments(false);
      return;
    }
    var sketchids = board.sketchdatas.map((s) => s.id);
    try {
      api.comment.sketch_get({ sketchids: sketchids, product_id: detail.id }).then(({ data }) => {
        const newSketchComments = {};
        for (var sketchcomment of data.sketchcomments) {
          sketchcomment.startX = sketchcomment.metadata.startX ?? NaN;
          sketchcomment.startY = sketchcomment.metadata.startY ?? NaN;
          sketchcomment.endX = sketchcomment.metadata.endX;
          sketchcomment.endY = sketchcomment.metadata.endY;
          sketchcomment.color = sketchcomment.metadata.color;
          sketchcomment.index = sketchcomment.metadata.index;
          sketchcomment.method = "comments";
          sketchcomment.newcomments =
            sketchcomment.latestcommentts &&
            sketchcomment.latestcommentts > (sketchcomment.viewcommentts[detail.user_id] ?? "");
          if (!(sketchcomment.sketch_id in newSketchComments))
            newSketchComments[sketchcomment.sketch_id] = [];
          newSketchComments[sketchcomment.sketch_id].push(sketchcomment);
        }
        setSketchComments(newSketchComments);
        setShowComments(data.sketchcomments.length > 0);
        return data;
      });
    } catch (err) {
      toast.error("load sketch comments failed!");
      console.log(err);
    }
  };

  const unDo = () => {
    if (stepHistoryIndex.current <= 0) return;
    stepHistoryIndex.current = stepHistoryIndex.current - 1;
    stepHistoryCheck.current = 0;
    setSketchDatas(stepHistory.current[stepHistoryIndex.current].sketchDatas);
    setTableFields(stepHistory.current[stepHistoryIndex.current].tableFields);
  };

  const reDo = () => {
    if (stepHistoryIndex.current >= stepHistory.current.length - 1) return;
    stepHistoryIndex.current = stepHistoryIndex.current + 1;
    stepHistoryCheck.current = 0;
    setSketchDatas(stepHistory.current[stepHistoryIndex.current].sketchDatas);
    setTableFields(stepHistory.current[stepHistoryIndex.current].tableFields);
  };

  function KeyPress(e) {
    var evtobj = window.event ? window.event : e;
    //console.log('evtobj', evtobj)
    var code = evtobj.keyCode || evtobj.which;
    if ((code == 90 || code == 122) && (evtobj.metaKey || evtobj.ctrlKey)) {
      console.log(evtobj.shiftKey ? "Redo" : "Undo");
      if (evtobj.shiftKey) reDo();
      else unDo();
    }
  }

  useEffect(() => {
    if (board) {
      refreshComments();
    }
    document.onkeydown = KeyPress;
    return () => {
      document.onkeydown = undefined;
    };
  }, []);

  useEffect(() => {
    if (!board) {
      const meta = detail?.style ? detail.style : {};
      setTechPacksFiles(meta?.techPacksFiles || []);
    } else {
      /*setSketchDatas(board.sketchdatas.map((s) => {
        return { ...s, lines: s.lines.filter((l) => l.method !== "comments") }
      }))
      console.log('useEffect board', board.sketchdatas)*/
    }
  }, [board]);

  useEffect(() => {
    //console.log('updateBoard', board?.sketchdatas, sketchDatas)
    if (
      board &&
      sketchDatas &&
      (!deepEqual(board.sketchdatas, sketchDatas) || !deepEqual(board.fields, tableFields))
    ) {
      board.sketchdatas = sketchDatas;
      board.fields = tableFields;
      board.collaborationhistory = collaborationHistory;
      //console.log('updateBoarding', board.sketchdatas)
      updateBoard(board.id, sketchDatas, tableFields, collaborationHistory);
      if (stepHistoryCheck.current == 1) {
        stepHistoryIndex.current = stepHistoryIndex.current + 1;
        if (stepHistoryIndex.current < stepHistory.current.length)
          stepHistory.current.splice(stepHistoryIndex.current);
        stepHistory.current.push({ sketchDatas: sketchDatas, tableFields: tableFields });
      } else if (stepHistoryCheck.current == 0) stepHistoryCheck.current = 1;
    }
  }, [sketchDatas, tableFields]);

  const handleResetTechPacksFiles = () => {
    const meta = detail?.style ? detail.style : {};
    setTechPacksFiles(meta?.techPacksFiles || []);
  };

  const handleSaveTechPacksFiles = async () => {
    try {
      setUploading(true);

      const myFiles = await handleUploadFiles(techPacksFiles);
      let payload = {
        style: {
          ...detail.style,
          techPacksFiles: myFiles,
        },
      };
      if (detail.id) {
        await api.products.update(detail.id, payload);
      } else {
        payload = {
          title: detail?.title || "Untitled",
          status: "design",
          description: "",
          options: [],
          collection_id: null,
          style: {
            techPacksFiles: myFiles,
          },
        };
        const newCreatedProduct = await api.products.create(payload);
        let product_id = newCreatedProduct?.data?.product?.id;
        if (product_id) {
          var url = new window.URL(document.location);
          url.searchParams.set("id", product_id);
          window.history.replaceState("", "style", url.toString());
        }
      }
      setUploading(false);
      detail.style.techPacksFiles = myFiles;
      toast.success("Update style tech pack files successfully!");
    } catch (err) {
      console.log(err);
      toast.error("Update failed!");
      setUploading(false);
    }
  };

  const addUrl = async (url, rid, filename, filetype) => {
    try {
      const { width, height } = await getImageDimensions(url);
      setSketchDatas((oldData) => [
        ...oldData,
        {
          id: rid,
          name: filename,
          type: filetype,
          imgurl: url,
          height: height,
          width: width,
          lines: [],
        },
      ]);
      setImageFilter("");
    } catch (err) {
      console.log(err);
      toast.error("File can not be processed due to incompatible format!");
    }
  };

  const handleUpload = async ({ file }) => {
    setUploading(true);
    var rid = nanoid();
    //console.log('file', file)
    var file2 = new File([file], rid + "_" + file.name, { type: file.type });
    const url = await api.uploads.create([file2]).then(({ data }) => {
      const uploaded = data.uploads.map(({ url }) => url);
      return uploaded;
    });
    if (url && url.length == 1) {
      addUrl(url, rid, file.name, file.type);
    }
    setUploading(false);
  };

  const findLine = (id) => {
    for (var sketchdata of sketchDatas) {
      for (var line of sketchdata.lines) {
        if (line.id === id) return { sketchdata: sketchdata, line: line };
      }
    }
  };

  const updateLine = (line) => {
    var sketchdata = findLine(line.id).sketchdata;
    const nextLines = sketchdata.lines.map((l) => {
      if (l.id === line.id) {
        return line;
      } else {
        return l;
      }
    });
    updateLines(sketchdata.id, [...nextLines]);
  };

  const deleteLine = (line, collaborationDelete = false) => {
    var sketchdata = findLine(line.id).sketchdata;
    const nextLines = collaborationDelete
      ? sketchdata.lines.map((l) => {
          if (l.id === line.id) {
            if ("PEProle" in l) return l;
            return {
              ...line,
              PEProle: detail.user_id,
              PEPname: detail.user_name,
              PEPdate: new Date(),
              v: line.index,
              PEPvalue: "",
            };
          } else {
            return l;
          }
        })
      : sketchdata.lines.filter((l) => l.id !== line.id);
    updateLines(sketchdata.id, [...nextLines]);
  };

  const updateLines = (id, lines) => {
    var nextSketchDatas = sketchDatas.map((s) => {
      if (s.id === id) {
        return { ...s, lines: lines };
      } else {
        return s;
      }
    });
    if (board.id === "BillMaterials")
      nextSketchDatas = nextSketchDatas.filter((sketchdata) => sketchdata.lines.length > 0);
    setTableFields(resizeColumns(tableFields, nextSketchDatas));
    setSketchDatas(nextSketchDatas);
    //setSelectedRows([])
  };

  const addCollaborationHistory = (h) => {
    setCollaborationHistory((prevHistory) => [{ ...h, dt: new Date() }, ...prevHistory]);
  };

  const updateImageRatio = (id, imgRatio, recordhistory) => {
    const nextSketchDatas = sketchDatas.map((s) => {
      if (s.id === id) {
        return { ...s, imgRatio: imgRatio };
      } else {
        return s;
      }
    });
    stepHistoryCheck.current = recordhistory ? 1 : 2;
    setSketchDatas(nextSketchDatas);
  };

  const updateRotation = (id, rotation) => {
    const nextSketchDatas = sketchDatas.map((s) => {
      if (s.id === id) {
        return { ...s, rotation: rotation };
      } else {
        return s;
      }
    });
    stepHistoryCheck.current = 1;
    setSketchDatas(nextSketchDatas);
  };

  const handleDrop = (droppedItem) => {
    if (!droppedItem.destination) return;
    var updatedList = [...sketchDatas];
    const [reorderedItem] = updatedList.splice(droppedItem.source.index, 1);
    updatedList.splice(droppedItem.destination.index, 0, reorderedItem);
    setSketchDatas(updatedList);
    setSelectedRows([]);
  };

  const EditColumns = ({}) => {
    const [columns, setColumns] = useState(
      tableFields?.filter((f) => f.disableReorder !== true).map((f) => ({ ...f, editable: true }))
    );
    const [localHistory, setLocalHistory] = useState([]);
    //console.log('tableFields', tableFields)

    const handleDrop2 = (droppedItem) => {
      if (!droppedItem.destination) return;
      var updatedList = [...columns];
      const [reorderedItem] = updatedList.splice(droppedItem.source.index, 1);
      updatedList.splice(droppedItem.destination.index, 0, reorderedItem);
      setColumns(updatedList);
    };

    return (
      <Dialog
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              width: "720px",
              height: "700px",
            },
          },
        }}
        open={editColumnDialogVisible}
        maxWidth={"lg"}
        onClose={() => setEditColumnDialogVisible(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Edit Columns</DialogTitle>
        <DialogContent>
          <DragDropContext onDragEnd={handleDrop2}>
            <Droppable droppableId="column-container" direction="vertical">
              {(provided) => (
                <div
                  style={{ display: "flex", flexDirection: "column", alignItems: "center" }}
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                >
                  {columns.map((column, index) => (
                    <Draggable
                      id={column.field}
                      key={column.field}
                      draggableId={column.field}
                      index={index}
                      isDragDisabled={column.field == "Code1"}
                    >
                      {(provided) => {
                        provided.draggableProps.style = {
                          ...provided.draggableProps.style,
                          width: "700px",
                        };
                        return (
                          <div
                            ref={provided.innerRef}
                            {...provided.dragHandleProps}
                            {...provided.draggableProps}
                          >
                            <SuiBox
                              sx={{ width: "700px", px: 1 }}
                              display="flex"
                              alignItems="center"
                              justifyContent="flex-start"
                            >
                              <DragHandleIcon
                                fontSize="small"
                                visibility={column.field == "Code1" ? "hidden" : ""}
                              />
                              <SuiTypography
                                sx={{
                                  textAlign: "right",
                                  width: "100px",
                                  minWidth: "100px",
                                  whiteSpace: "nowrap",
                                }}
                                variant="body1"
                              >
                                {index + 1}. Column
                              </SuiTypography>
                              {"PEProle" in column && (
                                <SuiBox display="flex" alignItems="center" sx={{ pl: 3, py: 1 }}>
                                  <SuiTypography variant="body1">
                                    {describePEP(column)}
                                  </SuiTypography>
                                  {column.PEProle === detail.user_id && (
                                    <SuiButton
                                      size="small"
                                      sx={{ ml: 1 }}
                                      onClick={() => {
                                        const newDatas = columns.map((c) => {
                                          if (column.field === c.field) {
                                            var newf = { ...c };
                                            deletePEPAttr(newf);
                                            return newf;
                                          } else return c;
                                        });
                                        setColumns(newDatas);
                                      }}
                                      color={"secondary"}
                                      variant="gradient"
                                    >
                                      Withdrawal
                                    </SuiButton>
                                  )}
                                  {column.PEProle !== detail.user_id && (
                                    <SuiButton
                                      size="small"
                                      sx={{ ml: 1 }}
                                      onClick={() => {
                                        const newDatas = columns.filter((c) => {
                                          return column.field !== c.field;
                                        });
                                        setLocalHistory([
                                          ...localHistory,
                                          { ...column, type: "field" },
                                        ]);
                                        setColumns(newDatas);
                                      }}
                                      color={"secondary"}
                                      variant="gradient"
                                    >
                                      Accept
                                    </SuiButton>
                                  )}
                                  {column.PEProle !== detail.user_id && (
                                    <SuiButton
                                      size="small"
                                      sx={{ ml: 1 }}
                                      onClick={() => {
                                        const newDatas = columns.map((c) => {
                                          if (column.field === c.field) {
                                            var newf = { ...c };
                                            deletePEPAttr(newf);
                                            return newf;
                                          } else return c;
                                        });
                                        setColumns(newDatas);
                                      }}
                                      color={"secondary"}
                                      variant="gradient"
                                    >
                                      Decline
                                    </SuiButton>
                                  )}
                                </SuiBox>
                              )}
                              {!("PEProle" in column) && (
                                <>
                                  <SuiBox sx={{ width: "400px", margin: "5px 20px" }}>
                                    <SuiInput
                                      autoFocus={column.headerName === ""}
                                      value={column.headerName}
                                      onChange={(e) => {
                                        const newDatas = columns.map((c) => {
                                          if (column.field === c.field)
                                            return { ...c, headerName: e.target.value };
                                          else return c;
                                        });
                                        setColumns(newDatas);
                                      }}
                                    />
                                  </SuiBox>
                                  <IconButton
                                    disabled={column.field == "Code"}
                                    size="medium"
                                    onClick={() => {
                                      const newDatas =
                                        editmode > 1
                                          ? columns.map((c) => {
                                              if (column.field === c.field)
                                                return {
                                                  ...c,
                                                  PEPdate: new Date(),
                                                  PEPname: detail.user_name,
                                                  PEProle: detail.user_id,
                                                  v: c.headerName,
                                                  PEPvalue: "",
                                                };
                                              else return c;
                                            })
                                          : columns.filter((c) => {
                                              return column.field !== c.field;
                                            });
                                      setColumns(newDatas);
                                    }}
                                  >
                                    <Icon
                                      fontSize="medium"
                                      className="border-none hover:bg-transparent"
                                    >
                                      clear
                                    </Icon>
                                  </IconButton>
                                </>
                              )}
                            </SuiBox>
                          </div>
                        );
                      }}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
        </DialogContent>
        <DialogActions>
          <SuiButton
            onClick={() => {
              setColumns([
                ...columns,
                { field: nanoid(), headerName: "", width: 100, editable: true },
              ]);
            }}
            color={"dark"}
            variant="gradient"
          >
            Add Column
          </SuiButton>
          <div style={{ flex: "1 0 0" }} />
          <SuiButton
            onClick={() => setEditColumnDialogVisible(false)}
            color={"secondary"}
            variant="gradient"
          >
            Cancel
          </SuiButton>
          <SuiButton
            onClick={() => {
              setEditColumnDialogVisible(false);
              for (var column of columns) column.width = Math.max(50, column.width);
              var newTableFields = tableFields
                .filter((f) => f.disableReorder === true)
                .concat(columns);
              newTableFields = resizeColumns(newTableFields, sketchDatas);
              setTableFields(newTableFields);
              for (var h of localHistory) addCollaborationHistory(h);
            }}
            color={"dark"}
            variant="gradient"
          >
            Update
          </SuiButton>
        </DialogActions>
      </Dialog>
    );
  };

  const AddParts = ({}) => {
    const [title, setTitle] = useState("");
    const [category, setCategory] = useState({ value: "Fabric", label: "Fabric" });
    const [bgImageData, setBgImageData] = useState({});

    useEffect(() => {
      var cat = addPartsDialogSketch?.lines[0].datas.Category ?? "Fabric";
      setTitle(addPartsDialogSketch?.lines[0].datas.Name ?? "");
      setCategory({ value: cat, label: cat });
      setBgImageData(addPartsDialogSketch?.lines[0].datas.ImageData ?? {});
    }, [addPartsDialogSketch]);

    const setPartsImg = async (data) => {
      setBgImageData({});
      var rid = nanoid();
      var base64str = await getBase64(data.file);
      const file = dataURLtoFile(base64str, rid);
      new Compressor(file, {
        maxWidth: 200,
        maxHeight: 200,
        quality: 0.92,
        mimeType: "image/jpeg",
        success: async (result) => {
          var file2 = new File([result], result.name, { type: "image/jpeg" });
          const url = await api.uploads.create([file2]).then(({ data }) => {
            const uploaded = data.uploads.map(({ url }) => url);
            return uploaded;
          });
          if (url && url.length == 1) {
            try {
              const { width, height } = await getImageDimensions(url);
              var imgObj = { type: file2.type, imgurl: url[0], height: height, width: width };
              setBgImageData(imgObj);
              return;
            } catch (err) {
              console.log(err);
              toast.error("File can not be processed due to incompatible format!");
              return;
            }
          }
        },
        error(err) {
          console.log(err.message);
        },
      });
    };

    const clickAdd = async () => {
      if (title === "") {
        toast.error("Please provide a valid title.");
        return;
      }
      setAddPartsDialogVisible(false);
      setUploading(true);
      var rid = nanoid();
      var newDatas = null;
      if (addPartsDialogSketch) {
        newDatas = sketchDatas.map((s) => {
          if (s.id !== addPartsDialogSketch.id) return s;
          var newdatas = { ...s.lines[0].datas };
          if (title !== newdatas.Name) {
            newdatas.Name =
              editmode > 1
                ? {
                    PEProle: detail.user_id,
                    PEPname: detail.user_name,
                    PEPdate: new Date(),
                    v: newdatas.Name,
                    PEPvalue: title,
                  }
                : title;
          }
          if (category.value !== newdatas.Category) {
            newdatas.Category =
              editmode > 1
                ? {
                    PEProle: detail.user_id,
                    PEPname: detail.user_name,
                    PEPdate: new Date(),
                    v: newdatas.Category,
                    PEPvalue: category.value,
                  }
                : category.value;
          }
          if (bgImageData?.imgurl !== newdatas.ImageData?.imgurl) {
            newdatas.ImageData =
              editmode > 1
                ? {
                    PEProle: detail.user_id,
                    PEPname: detail.user_name,
                    PEPdate: new Date(),
                    v: newdatas.ImageData,
                    PEPvalue: bgImageData,
                  }
                : bgImageData;
          }
          return { ...s, lines: [{ ...s.lines[0], datas: newdatas }] };
        });
      } else {
        var line = {
          id: nanoid(),
          index: getNextIntIndex(),
          method: "data",
          datas: {
            Name:
              editmode > 1
                ? {
                    PEProle: detail.user_id,
                    PEPname: detail.user_name,
                    PEPdate: new Date(),
                    v: "",
                    PEPvalue: title,
                  }
                : title,
            Category:
              editmode > 1
                ? {
                    PEProle: detail.user_id,
                    PEPname: detail.user_name,
                    PEPdate: new Date(),
                    v: "",
                    PEPvalue: category.value,
                  }
                : category.value,
            ImageData:
              editmode > 1
                ? {
                    PEProle: detail.user_id,
                    PEPname: detail.user_name,
                    PEPdate: new Date(),
                    v: "",
                    PEPvalue: bgImageData,
                  }
                : bgImageData,
          },
        };
        if (editmode > 1)
          line = {
            ...line,
            PEProle: detail.user_id,
            PEPname: detail.user_name,
            PEPdate: new Date(),
            v: "",
            PEPvalue: line.index,
          };
        var newObj = { id: rid, name: title, lines: [line] };
        if (editmode > 1)
          newObj = {
            ...newObj,
            PEProle: detail.user_id,
            PEPname: detail.user_name,
            PEPdate: new Date(),
            v: "",
            PEPvalue: newObj.name,
          };
        newDatas = [...sketchDatas, newObj];
      }
      setTableFields(resizeColumns(tableFields, newDatas));
      setSketchDatas(newDatas);
      setUploading(false);
    };

    return (
      <Dialog
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              width: "550px",
              height: "650px",
            },
          },
        }}
        open={addPartsDialogVisible}
        maxWidth={"lg"}
        onClose={() => setAddPartsDialogVisible(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {addPartsDialogSketch ? "Update" : "Add"} Parts
        </DialogTitle>
        <DialogContent>
          <SuiBox
            sx={{ width: "100%", my: 1 }}
            display="flex"
            alignItems="center"
            justifyContent="space-between"
          >
            <SuiTypography variant="body1">Category</SuiTypography>
            <SuiBox sx={{ width: "400px" }}>
              <SuiSelect
                size="medium"
                options={[
                  { value: "Fabric", label: "Fabric" },
                  { value: "Trim", label: "Trim" },
                  { value: "Hardware", label: "Hardware" },
                  { value: "Others", label: "Others" },
                ]}
                onChange={(option) => setCategory(option)}
                value={category}
              />
            </SuiBox>
          </SuiBox>
          <SuiBox
            sx={{ width: "100%", mb: 1 }}
            display="flex"
            alignItems="center"
            justifyContent="space-between"
          >
            <SuiTypography variant="body1" required>
              Name
            </SuiTypography>
            <SuiBox sx={{ width: "400px" }}>
              <SuiInput
                value={title}
                onChange={(e) => {
                  setTitle(e.target.value);
                }}
              />
            </SuiBox>
          </SuiBox>
          <SuiBox display="flex" flexDirection="column" justifyContent="flex-end">
            <SuiBox mb={1} ml={0} lineHeight={0} display="inline-block">
              <SuiTypography variant="body1"> Material Image (optional) </SuiTypography>
            </SuiBox>
            <SuiBox
              display="flex"
              alignItems="center"
              position="relative"
              height="10rem"
              borderRadius="xl"
              sx={{
                backgroundImage: bgImageData.imgurl
                  ? `url(${bgImageData.imgurl})`
                  : ({ functions: { rgba, linearGradient }, palette: { gradients } }) =>
                      `${linearGradient(
                        rgba(gradients.secondary.main, 0.2),
                        rgba(gradients.secondary.state, 0.4)
                      )}`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            />
          </SuiBox>
          <SuiBox
            sx={{ width: "100%", mt: 1 }}
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <Upload
              name="avatar"
              accept="image/*"
              showUploadList={false}
              customRequest={setPartsImg}
            >
              <SuiButton variant="gradient" color="dark">
                Upload
              </SuiButton>
            </Upload>
            {bgImageData !== "" && (
              <SuiButton
                variant="gradient"
                color="dark"
                sx={{ ml: 2 }}
                onClick={() => setBgImageData({})}
              >
                Clear
              </SuiButton>
            )}
          </SuiBox>
        </DialogContent>
        <DialogActions>
          <SuiButton
            onClick={() => setAddPartsDialogVisible(false)}
            color={"secondary"}
            variant="gradient"
          >
            Cancel
          </SuiButton>
          <SuiButton
            onClick={() => {
              clickAdd();
            }}
            color={"dark"}
            variant="gradient"
          >
            {addPartsDialogSketch ? "Update" : "Add"}
          </SuiButton>
        </DialogActions>
      </Dialog>
    );
  };

  const handleUploadTable = async ({ file }) => {
    //console.log('file', file)
    Papa.parse(file, {
      complete: function (results) {
        //console.log("Finished:", results.data);
        if (results.data.length <= 1) return;
        var fieldPos = [];
        var newFields = [...tableFields];
        for (var header of results.data[0]) {
          var find = newFields.find((f) => f.headerName === header);
          if (find) fieldPos.push(find);
          else {
            var newField = {
              field: nanoid(),
              headerName: header,
              hide: false,
              width: 100,
              editable: true,
            };
            fieldPos.push(newField);
            newFields.push(newField);
          }
        }
        var rowIndex = 0;
        const newDatas = sketchDatas.map((sketchdata) => {
          const newlines = sketchdata.lines.map((line) => {
            ++rowIndex;
            if (rowIndex < results.data.length) {
              var row = results.data[rowIndex];
              var newLineData = { ...line.datas };
              for (var index = 0; index < Math.min(fieldPos.length, row.length); ++index) {
                const f = fieldPos[index].field;
                var newv = row[index];
                if (editmode > 1)
                  newv = {
                    v: line.datas[f] ?? "",
                    PEProle: detail.user_id,
                    PEPname: detail.user_name,
                    PEPvalue: newv,
                    PEPdate: new Date(),
                  };
                newLineData[f] = newv;
              }
              return { ...line, datas: autoCalc(newLineData) };
            } else return line;
          });
          return { ...sketchdata, lines: newlines };
        });
        newFields = resizeColumns(newFields, newDatas);
        setTableFields(newFields);
        setSketchDatas(newDatas);
      },
    });
  };

  const boardCollCounts = countBoardCollaborationUpdates(detail, board);
  const boardSRCollCounts = countBoardCollaborationUpdates(detail, board, selectedRows);
  //console.log('boardSRCollCounts', boardSRCollCounts, 'boardCollCounts', boardCollCounts)
  const CustomToolbar = () => {
    const [importAnchor, setImportAnchor] = useState(null);
    const [importVisible, setImportVisible] = useState(false);

    const collaborationActions2 = (checkrole, isAccept) => {
      var result = collaborationActions(
        board,
        sketchDatas,
        checkrole,
        isAccept,
        selectedRows.length == 0 ? null : selectedRows,
        addCollaborationHistory
      );
      setTableFields(resizeColumns(result.newFields, result.newDatas));
      setSketchDatas(result.newDatas);
      setSelectedRows([]);
    };

    const handleCloseImportMenu = () => {
      setImportAnchor(null);
    };

    const ImportMenu = () => (
      <Menu open={Boolean(importAnchor)} onClose={handleCloseImportMenu} anchorEl={importAnchor}>
        <MenuItem>
          <Upload accept=".csv,.txt" showUploadList={false} customRequest={handleUploadTable}>
            CSV File
          </Upload>
        </MenuItem>
        <MenuItem
          onClick={() => {
            setImportVisible(true);
            handleCloseImportMenu();
          }}
        >
          <SuiTypography>Material Library</SuiTypography>
        </MenuItem>
      </Menu>
    );

    const formatCellNewValue = (value) => {
      if (value == undefined) {
        return "";
      }

      return editmode > 1
        ? {
            PEProle: detail.user_id,
            PEPname: detail.user_name,
            PEPdate: new Date(),
            v: "",
            PEPvalue: value,
          }
        : value;
    };

    const handleAddRecord = async (item, customizedColumns, index) => {
      const images = item?.images || [];
      let ImageData = {};
      if (images.length > 0) {
        const image = images[0];
        try {
          const { width, height } = await getImageDimensions(image["url"]);

          ImageData = {
            imgurl: image["url"],
            width: width,
            height: height,
            type: image["type"],
          };
        } catch (err) {
          toast.error("Error on loading image size!");
          console.log(err);
        }
      }

      let rowMap = {
        Name: formatCellNewValue(item?.name),
        Category: formatCellNewValue(item?.category),
        Code: formatCellNewValue(item?.code),
        ImageData: ImageData,
        Description: formatCellNewValue(item?.description),
      };

      for (let i = 0; i < customizedColumns.length; i++) {
        let field = customizedColumns[i]?.field;
        let headerName = customizedColumns[i]?.headerName;
        let flag = false;
        if (headerName && field) {
          for (let j = 0; j < tableFields.length; j++) {
            if (
              tableFields[j]["headerName"].toLowerCase() == headerName.toLowerCase() ||
              tableFields[j]["field"].toLowerCase() == headerName.toLowerCase()
            ) {
              let sourceTableField = tableFields[j]["field"];
              rowMap[sourceTableField] = formatCellNewValue(item?.[field]);
              flag = true;
              continue;
            }
          }
          if (!flag) {
            rowMap[headerName] = formatCellNewValue(item?.[field]);
          }
        }
      }

      var rid = nanoid();
      var line = {
        id: nanoid(),
        index: index,
        method: "data",
        datas: rowMap,
      };
      if (editmode > 1)
        line = {
          ...line,
          PEProle: detail.user_id,
          PEPname: detail.user_name,
          PEPdate: new Date(),
          v: "",
          PEPvalue: line.index,
        };
      var newObj = { id: rid, name: rowMap["Name"], lines: [line] };
      if (editmode > 1)
        newObj = {
          ...newObj,
          PEProle: detail.user_id,
          PEPname: detail.user_name,
          PEPdate: new Date(),
          v: "",
          PEPvalue: newObj.name,
        };

      return newObj;
    };

    const handleOk = async (data, customizedColumns) => {
      if (data.length == 0) return;
      try {
        let initialIndex = getNextIntIndex();
        let records = [];

        for (let i = 0; i < data.length; i++) {
          let record = await handleAddRecord(data[i], customizedColumns, initialIndex);
          initialIndex += 1;
          records.push(record);
        }
        let newDatas = [...sketchDatas, ...records];

        let newTableFields = [...tableFields];
        if (records.length > 0) {
          let currentHeaderNames = [];
          for (let j = 0; j < tableFields.length; j++) {
            currentHeaderNames.push(tableFields[j]["headerName"].toLowerCase());
            currentHeaderNames.push(tableFields[j]["field"].toLowerCase());
          }
          for (let k in records[0]?.lines?.[0]?.datas) {
            if (typeof k == "string" && !currentHeaderNames.includes(k.toLowerCase())) {
              newTableFields.push({ editable: true, field: k, headerName: k, width: 64 });
            }
          }
        }

        setTableFields(resizeColumns(newTableFields, newDatas));
        setSketchDatas(newDatas);
      } catch (err) {
        console.log(err);
        toast.error("Error on importing material!");
      }
    };

    //.css-xfknpk-MuiButtonBase-root-MuiButton-root
    var toolbarColor = "#344767"; //#17c1e8 //1778D2
    var hoverColor = toolbarColor;
    var buttonconfig = {
      p: 1,
      border: "0 none",
      "&:hover": { border: "0 none", color: hoverColor, opacity: 1 },
      "&:disabled": { border: "0 none" },
      "&:focus": { border: "0 none" },
      color: toolbarColor,
    };
    return (
      <GridToolbarContainer>
        {editmode > 0 && (
          <Tooltip
            title="Change the order of your columns or edit their names."
            placement="top-start"
          >
            <SuiButton
              variant="outlined"
              size="medium"
              startIcon={<EditIcon />}
              sx={buttonconfig}
              onClick={() => {
                setEditColumnDialogVisible(true);
              }}
            >
              Edit Columns
            </SuiButton>
          </Tooltip>
        )}
        {editmode > 0 && tableRows.length > 0 && (
          <Tooltip title="Delete selected rows" placement="top-start">
            <span>
              <SuiButton
                disabled={selectedRows.length === 0}
                variant="outlined"
                color="secondary"
                size="medium"
                startIcon={<DeleteIcon />}
                sx={buttonconfig}
                onClick={() => {
                  setDeleteSelectedDialogVisible(true);
                }}
              >
                Delete
              </SuiButton>
            </span>
          </Tooltip>
        )}
        {editmode > 1 && boardCollCounts.myCount > 0 && (
          <Tooltip title="Withdrawal my proposals from selected rows" placement="top-start">
            <span>
              <SuiButton
                disabled={boardSRCollCounts.myCount === 0}
                variant="outlined"
                color="secondary"
                size="medium"
                sx={buttonconfig}
                startIcon={<TiCancel />}
                onClick={() => {
                  collaborationActions2((r) => r === detail.user_id, false);
                }}
              >
                Withdrawal My Proposal
              </SuiButton>
            </span>
          </Tooltip>
        )}
        {(editmode === 1 || editmode === 3 || editmode === 4) && boardCollCounts.otherCount > 0 && (
          <Tooltip title="Accept proposals from selected rows" placement="top-start">
            <span>
              <SuiButton
                disabled={boardSRCollCounts.otherCount == 0}
                variant="outlined"
                color="secondary"
                size="medium"
                sx={buttonconfig}
                startIcon={<GiCheckMark />}
                onClick={() => {
                  collaborationActions2((r) => r !== detail.user_id, true);
                }}
              >
                Accept Proposal
              </SuiButton>
            </span>
          </Tooltip>
        )}
        {(editmode === 1 || editmode === 3 || editmode === 4) && boardCollCounts.otherCount > 0 && (
          <Tooltip title="Decline proposals from selected rows" placement="top-start">
            <span>
              <SuiButton
                disabled={boardSRCollCounts.otherCount == 0}
                variant="outlined"
                color="secondary"
                size="medium"
                sx={buttonconfig}
                startIcon={<GiCancel />}
                onClick={() => {
                  collaborationActions2((r) => r !== detail.user_id, false);
                }}
              >
                Decline Proposal
              </SuiButton>
            </span>
          </Tooltip>
        )}
        {tableRows.length > 0 && (
          <GridToolbarExport
            sx={{ color: toolbarColor, px: 1, "&:hover": { color: hoverColor } }}
            printOptions={{
              disableToolbarButton: false,
              hideFooter: true,
              hideToolbar: true,
              fields: tableFields
                .filter((f) => f.field !== "+" && f.hide !== true)
                .map((f) => f.field),
              fileName: detail.title + " " + board.title,
            }}
            csvOptions={{
              fileName: detail.title + " " + board.title,
              fields: tableFields
                .filter((f) => f.field !== "+" && f.hide !== true)
                .map((f) => f.field),
            }}
          />
        )}
        {tableRows.length > 0 && (
          <span>
            {board?.id === "BillMaterials" ? (
              <SuiButton
                variant="outlined"
                size="medium"
                startIcon={<UploadIcon />}
                sx={buttonconfig}
                onClick={(e) => {
                  setImportAnchor(e.target);
                }}
              >
                Import
              </SuiButton>
            ) : (
              <Upload accept=".csv,.txt" showUploadList={false} customRequest={handleUploadTable}>
                <SuiButton
                  variant="outlined"
                  size="medium"
                  startIcon={<UploadIcon />}
                  sx={buttonconfig}
                >
                  Import
                </SuiButton>
              </Upload>
            )}
          </span>
        )}
        {false && board?.id === "BillMaterials" && (
          <SuiButton
            variant="outlined"
            size="medium"
            onClick={(e) => {
              setTableFields([
                { field: "id", headerName: "id", hide: true, disableReorder: true },
                { field: "Code", headerName: "Parts", width: 100, disableReorder: true },
                {
                  field: "ImageData",
                  headerName: "Material Image",
                  width: 150,
                  editable: false,
                  disableReorder: true,
                },
                {
                  field: "Category",
                  headerName: "Category",
                  width: 100,
                  editable: false,
                  disableReorder: true,
                },
                {
                  field: "Name",
                  headerName: "Name",
                  width: 100,
                  editable: false,
                  disableReorder: true,
                },
                {
                  field: "Code",
                  headerName: "Code",
                  width: 100,
                  editable: true,
                  disableReorder: true,
                },
                { field: "Description", headerName: "Description", width: 150, editable: true },
                { field: "Quantity", headerName: "Quantity", width: 100, editable: true },
                { field: "UOM", headerName: "UOM", width: 100, editable: true },
                { field: "Price", headerName: "Price/unit($)", width: 100, editable: true },
                { field: "TotalCost", headerName: "Cost", width: 100, editable: false },
                { field: "Placement", headerName: "Placement", width: 100, editable: true },
                { field: "Supplier", headerName: "Supplier", width: 100, editable: true },
                { field: "Color", headerName: "Color", width: 100, editable: true },
                { field: "URL", headerName: "URL", width: 100, editable: true },
              ]);
            }}
            sx={buttonconfig}
          >
            Reset BOM Columns
          </SuiButton>
        )}
        {collaborationHistory.length > 0 && (
          <Tooltip title="" placement="top-start">
            <span>
              <SuiButton
                variant="outlined"
                color="secondary"
                size="medium"
                sx={buttonconfig}
                startIcon={<HistoryIcon />}
                onClick={() => {
                  setShowHistory(!showHistory);
                }}
              >
                {showHistory ? "Hide" : "Show"} History
              </SuiButton>
            </span>
          </Tooltip>
        )}
        {false && (
          <GridToolbarFilterButton
            sx={{ color: toolbarColor, px: 1, "&:hover": { color: hoverColor } }}
          />
        )}
        {false && (
          <Tooltip title="AutoFit Columns Width" placement="bottom">
            <SuiButton
              variant="outlined"
              size="medium"
              startIcon={<FitScreenIcon />}
              sx={buttonconfig}
              onClick={() => {
                setTableFields(resizeColumns(tableFields, sketchDatas));
              }}
            >
              AutoFit
            </SuiButton>
          </Tooltip>
        )}
        {false && (
          <GridToolbarDensitySelector
            sx={{ color: toolbarColor, px: 1, "&:hover": { color: hoverColor } }}
          />
        )}
        <ImportMenu />
        {importVisible ? (
          <ImportMaterialModal
            visible={importVisible}
            handleClose={() => setImportVisible(false)}
            handleOk={handleOk}
          />
        ) : null}
      </GridToolbarContainer>
    );
  };

  const getNextIntIndex = () => {
    var maxIndex = 0;
    for (var sketchdata of sketchDatas) {
      for (var l of sketchdata.lines) maxIndex = Math.max(maxIndex, l.index);
    }
    return maxIndex + 1;
  };

  const getNextIndex = () => {
    var indexArray = [];
    if (method == "comments") {
      for (var sketchdata of sketchDatas) {
        if (sketchdata.id in sketchComments) {
          for (var c of sketchComments[sketchdata.id]) indexArray.push(c.index);
        }
      }
      var commentindex = 0;
      while (indexArray.includes(String.fromCharCode(65 + commentindex))) {
        commentindex += 1;
      }
      return String.fromCharCode(65 + commentindex++);
    } else {
      return getNextIntIndex();
    }
  };

  var tableRows = [];
  var filteredSketchDatas = [];
  var commentsList = [];
  if (sketchDatas) {
    var sketchid = 0;
    for (var sketchdata of sketchDatas) {
      sketchdata.charid = String.fromCharCode(65 + sketchid++);
    }
    filteredSketchDatas = sketchDatas.filter(
      (sketchdata) => imageFilter == "" || sketchdata.id == imageFilter
    );
    for (const sketchdata of filteredSketchDatas) {
      for (var line of sketchdata.lines) {
        var code = line.index;
        if ("PEProle" in line) {
          code = {
            ...line,
            toString: function () {
              return this.index;
            },
          };
        }
        var row = { ...line.datas, index: line.index, color: line.color };
        Object.keys(row).forEach(function (key) {
          if (typeof row[key] === "object")
            row[key] = {
              ...row[key],
              toString: function () {
                return this.PEPvalue;
              },
            };
        });
        row.Code = code;
        row.id = line.id;
        tableRows.push(row);
      }
      if (sketchdata.id in sketchComments) {
        commentsList = commentsList.concat(sketchComments[sketchdata.id]);
      }
    }
    commentsList.sort((a, b) => (a.index < b.index ? -1 : 1));
    tableRows.sort((a, b) => (a.index < b.index ? -1 : 1));
    filteredSketchDatas = filteredSketchDatas.filter((sketchdata) => sketchdata.imgurl);
  }
  if (board?.id === "BillMaterials") tableRows.push({ id: nanoid() });
  var tableFields2 = [];
  for (const f of tableFields) {
    tableFields2.push({
      ...f,
      sortable: false,
      headerClassName:
        "PEProle" in f ? (f.PEProle === detail.user_id ? "mychange" : "otherchange") : "",
      headerName: f.headerName,
      headerAlign: "center",
      align: "center",
      renderHeader: (params) => {
        if ("PEProle" in f) {
          var tooltip = describePEP(f);
          return (
            <Tooltip
              placement="top"
              title={<span style={{ whiteSpace: "pre-line" }}>{tooltip}</span>}
            >
              <span style={{ width: "100%" }}>
                <del>{f.headerName}</del>
              </span>
            </Tooltip>
          );
        }
        return params.colDef.headerName;
      },
      valueFormatter: (params) => {
        if (params.field == "ImageData") {
          return params.value?.imgurl || params.value?.PEPvalue?.imgurl;
        } else {
          return params.value;
        }
      },
      renderCell: (params) => {
        if (
          board.id === "BillMaterials" &&
          tableRows[tableRows.length - 1].id === params.row.id &&
          params.field == "Code"
        ) {
          return (
            <SuiButton
              sx={{ mx: 1, p: 0, textTransform: "none", width: "100%" }}
              size="medium"
              variant="text"
              color="dark"
              onClick={(e) => {
                e.stopPropagation();
                setAddPartsDialogSketch(null);
                setAddPartsDialogVisible(true);
              }}
            >
              Add Parts
            </SuiButton>
          );
        }
        if (params.field == "ImageData") {
          if (!params.value) return params.value;
          //console.log('params.value', params.value)
          return (
            <div className="w-full flex justify-center">
              <img
                src={
                  typeof params.value === "object" && "PEProle" in params.value
                    ? params.value.PEPvalue.imgurl
                    : params.value.imgurl
                }
                height={40}
              />
            </div>
          );
        }
        var style = {};
        if (params.field == "Code") {
          style = {
            color: ["Black", "Violet", "Tomato"].includes(params.row.color) ? "white" : "black",
            backgroundColor: params.row.color,
            padding:
              params.value.PEPvalue > 9 || params.value > 9 ? "0px 3px 0px 3px" : "0px 7px 0px 7px",
            borderRadius: "11px",
          };
        }
        if (typeof params.value === "object") {
          var tooltip = describePEP(params.value);
          return (
            <Tooltip
              placement="top"
              title={<span style={{ whiteSpace: "pre-line" }}>{tooltip}</span>}
            >
              {params.value.PEPvalue === "" ? (
                <span style={style} className="w-fit flex justify-center">
                  <del>{params.value.v}</del>
                </span>
              ) : (
                <span style={style} className="w-fit flex justify-center">
                  {" "}
                  {params.value.PEPvalue}{" "}
                </span>
              )}
            </Tooltip>
          );
        }
        return (
          <span style={style} className="w-fit flex justify-center">
            {" "}
            {params.value}
          </span>
        );
      },
      valueGetter1: (params) => {
        if (typeof params.value === "object") {
          return params.value.PEPvalue;
        }
        return params.value;
      },
    });
  }
  tableFields2.push({
    hide: false,
    sortable: false,
    field: "+",
    headerName: editmode > 0 ? "+" : "",
    width: 64,
    disableReorder: true,
    editable: false,
    headerAlign: "center",
  });

  function maxOfCol(newSketchDatas, col) {
    if (col.field == "Code") return 80;
    if (col.field == "ImageData") return 110;
    var columnDatas = [col.headerName];
    for (var data of newSketchDatas) {
      for (var line of data.lines) {
        var cell = line.datas[col.field];
        if (cell !== null && cell !== undefined)
          columnDatas.push(
            typeof cell === "object" ? (cell.PEPvalue === "" ? cell.v : cell.PEPvalue) : cell
          );
      }
    }
    let invisibleContainer = document.createElement("div");
    invisibleContainer.style.visibility = "hidden";
    invisibleContainer.style.zIndex = "-9999999999";
    invisibleContainer.style.position = "absolute";
    invisibleContainer.style.fontSize = "16px";
    invisibleContainer.style.top = "0";
    invisibleContainer.style.left = "0";
    document.body.append(invisibleContainer);
    let widths = [];
    columnDatas.forEach((cell) => {
      let invisibleCell = document.createElement("div");
      invisibleCell.innerHTML = cell;
      invisibleCell.style.width = "max-content";
      invisibleCell.style.maxWidth = "none";
      invisibleCell.style.minWidth = "none";
      invisibleContainer.append(invisibleCell);
      widths.push(Math.ceil(invisibleCell.clientWidth));
      invisibleContainer.style.fontSize = "14px";
    });
    let max = Math.max(...widths);
    invisibleContainer.remove();
    return max;
  }

  function resizeColumns(newfields, newSketchDatas) {
    let cols = [];
    newfields.forEach((col) => {
      let maxColWidth = maxOfCol(newSketchDatas, col);
      cols.push({ ...col, width: Math.max(maxColWidth + 26, 64) });
    });
    return cols;
  }

  if (!board)
    return (
      <Card sx={{ p: 1, height: "100%", width: "100%" }}>
        {editmode === 0 && (
          <SuiBox key={"reference_files"} display="flex" py={1} pr={2} gap={1} alignItems="top">
            <SuiTypography
              variant="button"
              fontWeight="bold"
              textTransform="capitalize"
              sx={{ whiteSpace: "nowrap", mt: 1 }}
            >
              Tech Packs Files:
            </SuiTypography>
            <FilePreviewCard files={techPacksFiles} handleDelete={false} />
          </SuiBox>
        )}
        {editmode > 0 && (
          <Grid item xs={12} sm={12}>
            <Backdrop sx={{ color: "info", zIndex: (theme) => 99999 }} open={uploading}>
              <CircularProgress color="info" sx={{ mr: 1 }} size={32} />
              <SuiTypography variant="h6" fontWeight="medium" color="info">
                Uploading supporting files...
              </SuiTypography>
            </Backdrop>
            <SuiBox display="flex" flexDirection="column" justifyContent="flex-end" height="100%">
              <SuiBox ml={0.5} lineHeight={0} display="inline-block">
                <SuiTypography component="label" variant="h6" fontWeight="bold">
                  Tech Packs Files
                </SuiTypography>
              </SuiBox>
              <SuiBox mb={1.5} ml={0.5} mt={0.5} lineHeight={0} display="inline-block">
                <SuiTypography
                  component="label"
                  variant="caption"
                  fontWeight="regular"
                  color="text"
                >
                  Please upload your tech packs files here
                </SuiTypography>
              </SuiBox>
              <DropZone files={techPacksFiles} setfiles={setTechPacksFiles} />
            </SuiBox>
            <SuiBox
              pt={3}
              px={3}
              display="flex"
              justifyContent="end"
              alignItems={{ xs: "flex-start", sm: "center" }}
              flexDirection={{ xs: "column", sm: "row" }}
            >
              <SuiBox display="flex" flexDirection={{ xs: "column", sm: "row" }}>
                <SuiBox ml={{ xs: 0, sm: 1 }} mt={{ xs: 1, sm: 0 }}>
                  <SuiButton
                    variant="gradient"
                    size="medium"
                    onClick={handleResetTechPacksFiles}
                    className="mr-2"
                    color="light"
                  >
                    Reset
                  </SuiButton>
                </SuiBox>
              </SuiBox>
              <SuiBox display="flex" flexDirection={{ xs: "column", sm: "row" }}>
                <SuiBox ml={{ xs: 0, sm: 1 }} mt={{ xs: 1, sm: 0 }}>
                  <SuiButton
                    size="medium"
                    variant="gradient"
                    color="dark"
                    onClick={handleSaveTechPacksFiles}
                  >
                    Save
                  </SuiButton>
                </SuiBox>
              </SuiBox>
            </SuiBox>
          </Grid>
        )}
      </Card>
    );

  const saveCurrentCellValue = (isAccept) => {
    setContextMenu(null);
    console.log("saveCurrentCellValue", currentCell);
    if ("index" in currentCell.value) {
      const newDatas = sketchDatas.map((sketchdata) => {
        var newlines = sketchdata.lines.map((line) => {
          if (line.id === currentCell.line.id) {
            var newline = JSON.parse(JSON.stringify(line));
            if (isAccept) {
              addCollaborationHistory({
                ...newline,
                datas: undefined,
                type: "row",
                linecode: newline.index,
                PEPname: newline.PEPname,
              });
            }
            if ((isAccept && newline.v === "") || (!isAccept && newline.PEPvalue === "")) {
              deletePEPAttr(newline);
            } else if ((isAccept && newline.PEPvalue === "") || (!isAccept && newline.v === ""))
              return null;
            return newline;
          } else return line;
        });
        newlines = newlines.filter((line) => {
          return line !== null;
        });
        return { ...sketchdata, lines: newlines };
      });
      setTableFields(resizeColumns(tableFields, newDatas));
      setSketchDatas(newDatas);
    } else {
      var value = isAccept ? currentCell.value.PEPvalue : currentCell.value.v;
      const newDatas = sketchDatas.map((sketchdata) => {
        const newlines = sketchdata.lines.map((line) => {
          if (line.id === currentCell.line.id) {
            if (isAccept)
              addCollaborationHistory({
                ...currentCell.value,
                type: "cell",
                field: currentCell.colDef?.headerName,
                linecode: currentCell.line.index,
              });
            return {
              ...line,
              datas: autoCalc({ ...line.datas, [currentCell.colDef.field]: value }),
            };
          } else return line;
        });
        return { ...sketchdata, lines: newlines };
      });
      setTableFields(resizeColumns(tableFields, newDatas));
      setSketchDatas(newDatas);
    }
  };

  const deleteRows = (rows) => {
    var newDatas = sketchDatas.map((sketchdata) => {
      const newlines =
        editmode > 1
          ? sketchdata.lines.map((l) => {
              if (rows.includes(l.id)) {
                if ("PEProle" in l) return l;
                return {
                  ...l,
                  PEProle: detail.user_id,
                  PEPname: detail.user_name,
                  PEPdate: new Date(),
                  v: l.index,
                  PEPvalue: "",
                };
              } else {
                return l;
              }
            })
          : sketchdata.lines.filter((l) => {
              return !rows.includes(l.id);
            });
      return { ...sketchdata, lines: newlines };
    });
    if (board.id === "BillMaterials")
      newDatas = newDatas.filter((sketchdata) => sketchdata.lines.length > 0);
    setTableFields(resizeColumns(tableFields, newDatas));
    setSketchDatas(newDatas);
  };

  //console.log('collaborationHistory', collaborationHistory)
  const smartdate = require("smartdate");
  smartdate.init();
  const apiRef = useGridApiRef();
  return (
    <Card sx={{ p: 1, height: "100%", width: "100%" }}>
      {tableFields && tableFields.length > 2 && <EditColumns />}
      <Backdrop sx={{ color: "info", zIndex: (theme) => 99999 }} open={uploading}>
        <CircularProgress color="info" sx={{ mr: 1 }} size={32} />
        <SuiTypography variant="h6" fontWeight="medium" color="info">
          Uploading supporting files...
        </SuiTypography>
      </Backdrop>
      <AddParts />
      <Prompt
        heading="Delete Confirmation"
        text={`Are you sure you want to delete this image?`}
        visible={deleteImgDialogVisible}
        okText="Delete"
        okColor="dark"
        handleOk={() => {
          setDeleteImgDialogVisible(false);
          var newSketchDatas = null;
          if (editmode > 1) {
            newSketchDatas = sketchDatas.map((s) => {
              if (s.id !== deleteImage) return s;
              if (s.lines.length == 0) return null;
              var newlines = s.lines.map((l) => {
                if ("PEProle" in l) return l;
                return {
                  ...l,
                  PEProle: detail.user_id,
                  PEPname: detail.user_name,
                  PEPdate: new Date(),
                  v: l.index,
                  PEPvalue: "",
                };
              });
              return { ...s, lines: newlines };
            });
            newSketchDatas = newSketchDatas.filter((s) => {
              return s !== null;
            });
          } else {
            newSketchDatas = sketchDatas.filter((s) => s.id !== deleteImage);
          }
          setTableFields(resizeColumns(tableFields, newSketchDatas));
          setSketchDatas(newSketchDatas);
          setIsDragDisabled(true);
          setImageFilter("");
        }}
        handleClose={() => setDeleteImgDialogVisible(false)}
      />
      <Prompt
        heading="Delete Confirmation"
        text={`Are you sure you want to delete selected rows?`}
        visible={deleteSelectedDialogVisible}
        okText="Delete"
        okColor="dark"
        handleOk={() => {
          setDeleteSelectedDialogVisible(false);
          setSelectedRows([]);
          deleteRows(selectedRows);
        }}
        handleClose={() => setDeleteSelectedDialogVisible(false)}
      />
      {sketchDatas?.length > 0 || stepHistory.current.length > 1 ? (
        <SuiBox sx={{ mb: 0, flexWrap: "wrap" }} display="flex" alignItems="center">
          {editmode > 0 && board.id !== "Sketches" && board.id !== "BillMaterials" && (
            <SuiBox
              sx={{ px: 1, borderLeft: "2px solid #E0E0E0" }}
              display="flex"
              alignItems="center"
            >
              <AnnotationMethods color={color} method={method} setMethod={setMethod} />
            </SuiBox>
          )}
          {board.id !== "Sketches" && board.id !== "BillMaterials" && (
            <SuiBox
              sx={{ px: 1, borderLeft: "2px solid #E0E0E0" }}
              display="flex"
              alignItems="center"
            >
              <AnnotationColors color={color} setColor={setColor} />
            </SuiBox>
          )}
          {board.id !== "BillMaterials" && (
            <SuiBox
              sx={{ px: 1, borderLeft: "2px solid #E0E0E0" }}
              display="flex"
              alignItems="center"
            >
              <Tooltip title={`Add comments on top of image`} placement="top-start">
                <IconButton
                  sx={{ mx: 0 }}
                  size="inherit"
                  style={method == "comments" ? { backgroundColor: "LightGrey" } : {}}
                  onClick={() => {
                    if (method !== "comments") {
                      setMethod("comments");
                      setShowComments(true);
                    } else setMethod("");
                  }}
                >
                  <CommentIcon
                    fontSize="inherit"
                    style={{ color: color }}
                    className="border-none hover:bg-transparent"
                  />
                </IconButton>
              </Tooltip>
              {false && (
                <SuiButton
                  sx={{ mx: 0, my: 0, p: 0, textTransform: "none" }}
                  color="dark"
                  variant="text"
                  onClick={(e) => {
                    setMethod("comments");
                    setShowComments(true);
                  }}
                >
                  Add
                  <br />
                  Comments
                </SuiButton>
              )}
              <Switch
                sx={{ mx: 1 }}
                checked={showComments}
                onChange={() => setShowComments(!showComments)}
              />
              <SuiButton
                sx={{ mx: 0, my: 0, p: 0, textTransform: "none" }}
                color="dark"
                variant="text"
                onClick={(e) => {
                  setShowComments(!showComments);
                }}
              >
                {showComments ? "Hide" : "Show"}
                <br />
                Comments
              </SuiButton>
            </SuiBox>
          )}
          {board.id !== "BillMaterials" && (
            <SuiBox
              sx={{ px: 1, borderLeft: "2px solid #E0E0E0" }}
              display="flex"
              alignItems="center"
            >
              <Tooltip
                title={`Increase image height from ${sketchHeight} to ${sketchHeight + 100} pixels`}
                placement="top-start"
              >
                <IconButton
                  sx={{ mx: 0 }}
                  size="medium"
                  onClick={() => {
                    setSketchHeight(sketchHeight + 100);
                  }}
                >
                  <ZoomInIcon
                    fontSize="medium"
                    color="inherit"
                    className="border-none hover:bg-transparent"
                  />
                </IconButton>
              </Tooltip>
              <Tooltip
                title={`Decrease image height from ${sketchHeight} to ${
                  sketchHeight > 100 ? sketchHeight - 100 : sketchHeight
                } pixels`}
                placement="top-start"
              >
                <IconButton
                  sx={{ mx: 0 }}
                  size="medium"
                  onClick={() => {
                    if (sketchHeight > 100) setSketchHeight(sketchHeight - 100);
                  }}
                >
                  <ZoomOutIcon
                    fontSize="medium"
                    color="inherit"
                    className="border-none hover:bg-transparent"
                  />
                </IconButton>
              </Tooltip>
            </SuiBox>
          )}
          {editmode > 0 && board.id !== "Sketches" && board.id !== "BillMaterials" && (
            <SuiBox
              sx={{ pr: 1, borderLeft: "2px solid #E0E0E0" }}
              display="flex"
              alignItems="center"
            >
              <Tooltip title={`Undo`} placement="top-start">
                <span>
                  <IconButton
                    sx={{ mx: 0 }}
                    disabled={stepHistoryIndex.current <= 0}
                    size="medium"
                    onClick={() => {
                      unDo();
                    }}
                  >
                    <Icon
                      fontSize="medium"
                      color="inherit"
                      className="border-none hover:bg-transparent"
                    >
                      undo
                    </Icon>
                  </IconButton>
                </span>
              </Tooltip>
              <Tooltip title={`Redo`} placement="top-start">
                <span>
                  <IconButton
                    sx={{ mx: 0 }}
                    disabled={stepHistoryIndex.current >= stepHistory.current.length - 1}
                    size="medium"
                    onClick={() => {
                      reDo();
                    }}
                  >
                    <Icon
                      fontSize="medium"
                      color="inherit"
                      className="border-none hover:bg-transparent"
                    >
                      redo
                    </Icon>
                  </IconButton>
                </span>
              </Tooltip>
            </SuiBox>
          )}
          {false && (
            <SuiBox
              sx={{ px: 1, borderLeft: "2px solid #E0E0E0" }}
              display="flex"
              alignItems="center"
            >
              <SuiButton
                sx={{ mx: 0, my: 0, px: 1, py: 0 }}
                size="medium"
                variant="gradient"
                color="dark"
                onClick={() => setExportPdfDialogVisible(true)}
              >
                Export
                <br />
                PDF
              </SuiButton>
              <ExportPdf
                detail={detail}
                exportPdfDialogVisible={exportPdfDialogVisible}
                setExportPdfDialogVisible={setExportPdfDialogVisible}
                styleTitle={detail.title}
                boards={[board]}
              />
            </SuiBox>
          )}
        </SuiBox>
      ) : (
        <SuiTypography variant="h6">
          {editmode
            ? board.id === "BillMaterials"
              ? 'Please click "Add Parts" button to add material parts.'
              : `Please click "Upload/Drop ${
                  board.id === "Sketches" ? "Sketch" : "Images"
                }" button to select image files or drag and drop image files to below area.`
            : "No uploaded image files."}
        </SuiTypography>
      )}
      {board.id !== "BillMaterials" && (
        <Grid container spacing={2} sx={{ pt: 5 }}>
          <Grid item xs={12} sm={showComments ? 8 : 12} md={showComments ? 8 : 12}>
            <SuiBox
              className="flex flex-row"
              sx={{ width: "100%" }}
              style={{ overflowX: "auto", overflowY: "hidden" }}
            >
              <DragDropContext onDragEnd={handleDrop}>
                <Droppable droppableId="list-container" direction="horizontal">
                  {(provided) => (
                    <div
                      style={{ display: "flex", alignItems: "start" }}
                      {...provided.droppableProps}
                      ref={provided.innerRef}
                      onClick={(e) => {
                        e.stopPropagation();
                      }}
                    >
                      {filteredSketchDatas.map((sketchdata, index) => (
                        <Draggable
                          key={sketchdata.id}
                          draggableId={sketchdata.id}
                          index={index}
                          isDragDisabled={isDragDisabled || !editmode}
                        >
                          {(provided) => (
                            <div
                              ref={provided.innerRef}
                              {...provided.dragHandleProps}
                              {...provided.draggableProps}
                              style={{
                                marginRight: "5px",
                                minWidth:
                                  2 +
                                  sketchHeight *
                                    ((sketchdata.rotation ?? 0) == 0 ||
                                    (sketchdata.rotation ?? 0) == 2
                                      ? sketchdata.width / sketchdata.height
                                      : sketchdata.height / sketchdata.width) *
                                    (sketchdata.imgRatio ?? 1),
                              }}
                            >
                              <Sketch
                                detail={detail}
                                board={board}
                                editmode={editmode}
                                sketchdata={sketchdata}
                                sketchcomments={sketchComments[sketchdata.id]}
                                sketchHeight={sketchHeight}
                                color={color}
                                method={method}
                                updateLines={updateLines}
                                refreshComments={refreshComments}
                                updateImageRatio={updateImageRatio}
                                updateRotation={updateRotation}
                                tableFields={tableFields}
                                setIsDragDisabled={setIsDragDisabled}
                                setImageFilter={setImageFilter}
                                setDeleteImage={setDeleteImage}
                                setDeleteImgDialogVisible={setDeleteImgDialogVisible}
                                sketchDatas={sketchDatas}
                                imageFilter={imageFilter}
                                showComments={showComments}
                                setSketchToolTip={setSketchToolTip}
                                getNextIndex={getNextIndex}
                                addCollaborationHistory={addCollaborationHistory}
                              />
                            </div>
                          )}
                        </Draggable>
                      ))}
                      {provided.placeholder}
                      {editmode > 0 && board.id !== "BillMaterials" && (
                        <div
                          onDrop={async (e) => {
                            e.preventDefault();
                            for (var file of e.dataTransfer?.files) {
                              await handleUpload({ file });
                            }
                            var url = e.dataTransfer?.getData("text/uri-list");
                            if (url === undefined || url === "") {
                              var htmlstr = e.dataTransfer?.getData("text/html");
                              //console.log('htmlstr', htmlstr)
                              if (htmlstr !== undefined && htmlstr !== "") {
                                var el = document.createElement("html");
                                el.innerHTML = htmlstr;
                                var imgnodes = el.getElementsByTagName("img");
                                if (imgnodes.length === 1) url = imgnodes[0].src;
                              }
                            }
                            if (url !== undefined && url !== "") {
                              var extension = url.split(/[#?]/)[0].split(".").pop().trim();
                              var type = extension !== "" ? "img/" + extension : "img/png";
                              console.log("url", url, "type", type);
                              addUrl([url], nanoid(), "", type);
                            }
                          }}
                          onDragOver={(e) => e.preventDefault()}
                        >
                          <Card
                            sx={{
                              width: "200px",
                              height: filteredSketchDatas.length > 0 ? sketchHeight + 37 : 200,
                            }}
                          >
                            <SuiBox
                              sx={{ width: "100%", height: "100%" }}
                              className="flex items-center justify-center"
                            >
                              <Upload
                                accept="image/*"
                                fileList={[]}
                                multiple
                                showUploadList={false}
                                customRequest={handleUpload}
                              >
                                <SuiButton
                                  sx={{ mx: 0, p: 0, textTransform: "none" }}
                                  size="medium"
                                  variant="text"
                                  color="dark"
                                  startIcon={<UploadIcon fontSize="large" />}
                                >
                                  Upload/Drop {board.id === "Sketches" ? "Sketch" : "Images"}
                                </SuiButton>
                              </Upload>
                            </SuiBox>
                          </Card>
                        </div>
                      )}
                    </div>
                  )}
                </Droppable>
              </DragDropContext>
            </SuiBox>
          </Grid>
          {showComments && (
            <Grid item xs={12} sm={4} md={4}>
              <Card sx={{ borderRadius: 2 }}>
                <EditComments
                  comments={currentAnnot}
                  commentsDialogVisible={commentsDialogVisible}
                  setCommentsDialogVisible={setCommentsDialogVisible}
                  refreshComments={refreshComments}
                  detail={detail}
                  board={board}
                />
                <SuiBox sx={{ height: sketchHeight + 37 }}>
                  <SuiBox
                    sx={{ display: "flex", justifyContent: "space-between" }}
                    alignItems="center"
                  >
                    <SuiTypography variant="h6" sx={{ ml: 1 }}>
                      Comments:
                    </SuiTypography>
                    <IconButton
                      aria-label="close"
                      onClick={() => setShowComments(false)}
                      sx={{
                        color: (theme) => theme.palette.grey[500],
                      }}
                    >
                      <CloseIcon />
                    </IconButton>
                  </SuiBox>
                  <ul style={{ overflowY: "auto", maxHeight: sketchHeight }}>
                    {commentsList.length == 0 && (
                      <SuiTypography variant="caption" sx={{ m: 1 }}>
                        Tips: select "Add Comments" and click on image to create a new Comment entry
                      </SuiTypography>
                    )}
                    {commentsList.map((sc) => (
                      <SuiBox key={sc.index} sx={{ m: 1 }}>
                        <a
                          onClick={() => {
                            setCurrentAnnot(sc);
                            setCommentsDialogVisible(true);
                          }}
                        >
                          <SuiTypography variant="button" className={`block text-gray-600`}>
                            #{sc.index}
                          </SuiTypography>
                          <SuiBox display="flex" justifyContent="center" alignItems="center">
                            <Badge variant="dot" color="error" invisible={!sc.newcomments}>
                              <ContactAvatar room={sc} />
                            </Badge>
                            <div className="w-full pb-2 ml-1">
                              <div className="flex justify-between items-center">
                                <SuiTypography
                                  className={`text-gray-600`}
                                  variant="body1"
                                  textTransform="none"
                                  sx={{
                                    width: "100%",
                                    minHeight: "16px",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    display: "-webkit-box",
                                    WebkitLineClamp: "1",
                                    WebkitBoxOrient: "vertical",
                                  }}
                                >
                                  {sc.content ?? " "}
                                </SuiTypography>
                              </div>
                              <div className="flex justify-between items-center">
                                <SuiTypography variant="caption">
                                  {sc.commentCnts ?? 0} Comments
                                </SuiTypography>
                                <SuiTypography variant="caption">
                                  {smartdate.format(new Date(sc.timestamp))}
                                </SuiTypography>
                              </div>
                            </div>
                          </SuiBox>
                        </a>
                      </SuiBox>
                    ))}
                  </ul>
                </SuiBox>
              </Card>
            </Grid>
          )}
        </Grid>
      )}
      {false && (
        <SuiBox className="flex flex-row" sx={{ width: "100%", pb: 5 }}>
          {sketchDatas?.length > 0 && (
            <SketchToolTip ref={sketchTooltipRef} color={color} method={method} />
          )}
        </SuiBox>
      )}
      {board.id !== "Sketches" && (
        <Grid container spacing={2} sx={{ pt: board?.id !== "BillMaterials" ? 5 : 0 }}>
          <Grid item xs={12} sm={showHistory ? 7 : 12} md={showHistory ? 7 : 12}>
            <SuiBox sx={{ height: 468, overflowY: "auto", width: "100%" }} ref={gridRef}>
              <EditAnnot
                editmode={editmode}
                annot={currentAnnot}
                tableFields={tableFields}
                annotDialogVisible={annotDialogVisible}
                setAnnotDialogVisible={setAnnotDialogVisible}
                updateLine={updateLine}
                deleteLine={deleteLine}
                detail={detail}
                addCollaborationHistory={addCollaborationHistory}
              />
              <Menu
                open={contextMenu !== null}
                onClose={() => setContextMenu(null)}
                anchorReference="anchorPosition"
                anchorPosition={
                  contextMenu !== null
                    ? { top: contextMenu.mouseY + 10, left: contextMenu.mouseX + 10 }
                    : undefined
                }
                componentsProps={{
                  root: {
                    onContextMenu: (e) => {
                      e.preventDefault();
                      setContextMenu(null);
                    },
                  },
                }}
              >
                {currentCell?.value?.PEProle === detail.user_id && (
                  <MenuItem
                    onClick={() => {
                      saveCurrentCellValue(false);
                    }}
                  >
                    Withdrawal
                  </MenuItem>
                )}
                {currentCell?.value?.PEProle && currentCell?.value?.PEProle !== detail.user_id && (
                  <MenuItem
                    onClick={() => {
                      saveCurrentCellValue(true);
                    }}
                  >
                    Accept
                  </MenuItem>
                )}
                {currentCell?.value?.PEProle && currentCell?.value?.PEProle !== detail.user_id && (
                  <MenuItem
                    onClick={() => {
                      saveCurrentCellValue(false);
                    }}
                  >
                    Decline
                  </MenuItem>
                )}
                {!currentCell?.value?.PEProle && (
                  <MenuItem
                    onClick={() => {
                      setContextMenu(null);
                      deleteRows([currentCell.line.id]);
                    }}
                  >
                    Delete Row
                  </MenuItem>
                )}
              </Menu>
              <DataGridPro
                apiRef={apiRef}
                experimentalFeatures={{ newEditingApi: true }}
                checkboxSelection
                disableColumnMenu
                hideFooterPagination
                hideFooter
                disableSelectionOnClick
                showCellRightBorder
                showColumnRightBorder
                //disableColumnReorder
                disableColumnResize
                density="compact"
                editMode="row"
                isCellEditable={(params) => {
                  //console.log('params', params.value)
                  return (
                    editmode !== 0 &&
                    !(typeof params.value === "object" && "PEProle" in params.value)
                  );
                }}
                selectionModel={selectedRows}
                onSelectionModelChange={(model) => {
                  setSelectedRows(model);
                }}
                columns={tableFields2}
                rows={tableRows}
                components={{ Toolbar: CustomToolbar }}
                sx={{
                  "@media print": {
                    ".MuiDataGrid-main": {
                      fontSize: "14px",
                    },
                    marginBottom: 1000,
                  },
                  "& .MuiDataGrid-cell": {
                    fontSize: "14px",
                  },
                  "& .MuiInputBase-root": {
                    border: "none",
                    outline: "none",
                  },
                  "& .MuiInputBase-input": {
                    border: "none",
                    outline: "none",
                  },
                  "& .MuiDataGrid-columnHeader": {
                    fontSize: "16px",
                  },
                  "& .MuiDataGrid-row.Mui-selected": {
                    backgroundColor: "rgba(25, 118, 210, 0.08)",
                  },
                  "& .MuiDataGrid-cell:focus": {
                    outline: "none",
                  },
                  "& .MuiDataGrid-cellCheckbox:focus": {
                    outline: "none",
                  },
                  "& .MuiDataGrid-columnHeader:focus": {
                    outline: "none",
                  },
                  "& .MuiDataGrid-cell.MuiDataGrid-cell--editing:focus-within": {
                    outline: "none",
                  },
                  "& .MuiDataGrid-columnHeaderTitleContainerContent": {
                    paddingBottom: "1px",
                  },
                  "& .MuiDataGrid-main": {
                    borderTop: "1px solid rgba(224, 224, 224, 1)",
                  },
                  "& .mychange": {
                    backgroundColor: "#b9d5ff91",
                    color: "#1a3e72",
                  },
                  "& .otherchange": {
                    backgroundColor: "#ff943975",
                    color: "#1a3e72",
                  },
                }}
                getCellClassName={(params) => {
                  //console.log('getCellClassName', params)
                  var value = params.value;
                  if (typeof value === "object" && "PEProle" in value) {
                    if (value.PEProle === detail.user_id) return "mychange";
                    return "otherchange";
                  }
                  return "";
                }}
                processRowUpdate={(newRow, oldRow) => {
                  //console.log('processRowUpdate', newRow)
                  const newDatas = sketchDatas.map((sketchdata) => {
                    const newlines = sketchdata.lines.map((line) => {
                      if (line.id === newRow.id) {
                        var newdatas = Object.entries(newRow).filter(
                          ([n, v]) => n !== "id" && n !== "Code" && v !== undefined
                        );
                        if (editmode > 1) {
                          newdatas = newdatas.map((d) => {
                            var oldv = oldRow[d[0]] ?? "";
                            if (d[1] === oldv) return d;
                            console.log("d", d);
                            const newv = {
                              v: oldv,
                              PEProle: detail.user_id,
                              PEPname: detail.user_name,
                              PEPvalue: d[1],
                              PEPdate: new Date(),
                            };
                            return [d[0], newv];
                          });
                        }
                        //console.log('processRowUpdate', line.datas, newdatas)
                        return { ...line, datas: autoCalc(Object.fromEntries(newdatas)) };
                      } else return line;
                    });
                    return { ...sketchdata, lines: newlines };
                  });
                  setTableFields(resizeColumns(tableFields, newDatas));
                  setSketchDatas(newDatas);
                  return newRow;
                }}
                onCellClick={(params, event) => {
                  if (editmode == 0) return;
                  //console.log('onCellClick', params, detail.user_id)
                  if (
                    params.field === "Code" ||
                    (typeof params.value === "object" && "PEProle" in params.value)
                  ) {
                    if (
                      typeof params.value === "object" &&
                      editmode == 2 &&
                      detail.user_id !== params.value.PEProle
                    )
                      return;
                    setCurrentCell({
                      role: detail.user_id,
                      colDef: params.colDef,
                      value: params.value,
                      line: findLine(params.id).line,
                    });
                    setContextMenu(
                      contextMenu === null ? { mouseX: event.clientX, mouseY: event.clientY } : null
                    );
                    return;
                  }
                  if (
                    board.id === "BillMaterials" &&
                    (params.field === "ImageData" ||
                      params.field === "Category" ||
                      params.field === "Name")
                  ) {
                    setAddPartsDialogVisible(true);
                    setAddPartsDialogSketch(findLine(params.id)?.sketchdata);
                  }
                  if (params.colDef.editable === false) return;
                  if (apiRef.current.getRowMode(params.id) === "view")
                    apiRef.current.startRowEditMode({ id: params.id, field: params.colDef.field });
                }}
                onColumnHeaderClick={(params, event, details) => {
                  if (editmode == 0) return;
                  console.log("onColumnHeaderClick", params);
                  if (params.field === "+" || "PEProle" in params.colDef)
                    setEditColumnDialogVisible(true);
                }}
                onColumnOrderChange={(params, event, details) => {
                  var tableFields2 = JSON.parse(JSON.stringify(tableFields));
                  const x = tableFields2.splice(params.oldIndex - 1, 1);
                  tableFields2.splice(params.targetIndex - 1, 0, x[0]);
                  setTableFields(tableFields2);
                }}
              />
            </SuiBox>
          </Grid>
          {showHistory && (
            <Grid item xs={12} sm={5} md={5}>
              <Card sx={{ borderRadius: 2 }}>
                <SuiBox sx={{ height: 468 }}>
                  <SuiBox
                    sx={{ display: "flex", justifyContent: "space-between" }}
                    alignItems="center"
                  >
                    <SuiTypography variant="h6" sx={{ ml: 1 }}>
                      Collaboration History:
                    </SuiTypography>
                    <IconButton
                      aria-label="close"
                      onClick={() => setShowHistory(false)}
                      sx={{
                        color: (theme) => theme.palette.grey[500],
                      }}
                    >
                      <CloseIcon />
                    </IconButton>
                  </SuiBox>
                  <ul style={{ overflowY: "auto", height: "100%" }}>
                    {collaborationHistory.map((ch, index) => {
                      //console.log('ch', ch)
                      var text = "";
                      if (ch.type == "cell")
                        text = "Code: " + ch.linecode + ". Column: " + ch.field;
                      else if (ch.type == "row") text = "Code: " + ch.linecode;
                      else if (ch.type == "field") text = "Column: " + ch.headerName;
                      return (
                        <SuiBox key={index} sx={{ m: 1 }}>
                          <SuiBox
                            sx={{ display: "flex", justifyContent: "space-between" }}
                            alignItems="center"
                          >
                            <SuiTypography
                              sx={{ mr: 1 }}
                              variant="body1"
                              className={`block text-gray-600`}
                            >
                              {text}
                            </SuiTypography>
                            <SuiTypography variant="caption" className={`block text-gray-600`}>
                              {moment(ch.dt).format("yyyy-MM-DD")}
                            </SuiTypography>
                          </SuiBox>
                          <SuiBox sx={{ display: "flex" }} alignItems="center">
                            <SuiTypography variant="body1" className={`block text-gray-600`}>
                              {describePEP(ch, false)}
                            </SuiTypography>
                          </SuiBox>
                        </SuiBox>
                      );
                    })}
                  </ul>
                </SuiBox>
              </Card>
            </Grid>
          )}
        </Grid>
      )}
    </Card>
  );
};

export default DevelopBoard;
